import { constants } from "../constants/redux-constants";

const initialState = {
  package: {},
  plan_status: "",
  usersLimit: null,
};

const licenseReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants?.LICENSE?.PACKAGE:
      return {
        ...state,
        package: action?.payload,
      };

    case constants?.LICENSE?.PLAN_STATUS:
      return {
        ...state,
        plan_status: action?.payload,
      };

    case constants?.LICENSE?.SET_USERS_LIMIT:
      return {
        ...state,
        usersLimit: action?.payload,
      };

    default:
      return {
        ...state,
      };
  }
};

export default licenseReducer;
